<template>
  <div class="lottie-container">
    <lottie-player
      :class="{ hidden: !lottieIsReversed }"
      ref="lottieReversed"
      :id="props.id"
      :src="props.reverseSrc"
    />
    <lottie-player :class="{ hidden: lottieIsReversed }" ref="lottie" :id="props.id" :src="src" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  src: string;
  reverseSrc?: string;
  id: string;
  containerId: string;
}>();

const lottie = ref();
const lottieReversed = ref();

const lottieIsReversed = ref(false);

function playAnimation(isReversed: boolean): void {
  lottieIsReversed.value = isReversed && !!props.reverseSrc;
  if (lottieIsReversed.value) {
    lottieReversed.value.seek("99%");
    lottieReversed.value.setDirection(-1);
    lottieReversed.value.play();
  } else {
    lottie.value.seek("0%");
    lottie.value.setDirection(1);
    lottie.value.play();
  }
}

defineExpose({
  playAnimation,
  lottie,
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
.lottie-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
